import { CircleAlert } from "lucide-react"
import { Button } from "../buttons"

export const ExceededLimitsMessage = ({ limitsOn }: { limitsOn: string }) => {
	const showMessageInIntercom = () => {
		const message = `Hi, I've reached the limit of ${limitsOn} available on my account and would like to discuss options for adding more.`
		if (window.Intercom) {
			Intercom("showNewMessage", message)
		}
	}

	return (
		<div className="mt-3 flex items-center gap-2 text-sm text-error-600">
			<CircleAlert className="h-4 w-4" />
			<span>
				You've exceeded the number of {limitsOn} included in your current subscription. Contact our{" "}
				<Button variant="link" onClick={showMessageInIntercom} data-testid="limits-warning-button" className="p-0">
					Customer Success
				</Button>{" "}
				team to upgrade.
			</span>
		</div>
	)
}
